export const HOME = '/';
export const VERSION = '/version';
export const AUTH_REDIRECT = '/cognito-callback';
